import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "las la-reply",
  style: {"font-size":"1.5em"}
}, null, -1)
const _hoisted_6 = { class: "card-body p-9" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên bộ phận:")
], -1)
const _hoisted_9 = { class: "col-3 d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mã bộ phận:")
], -1)
const _hoisted_13 = { class: "col-3 d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mô tả:")
], -1)
const _hoisted_17 = { class: "col-8 d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Địa chỉ:")
], -1)
const _hoisted_21 = { class: "col-8 d-flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Đơn vị:")
], -1)
const _hoisted_25 = { class: "col-8 d-flex align-items-center" }
const _hoisted_26 = { class: "d-flex mt-5 justify-content-end row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isCreating ? "Tạo mới" : "Chỉnh sửa") + " bộ phận ", 1)
      ]),
      _createVNode(_component_router_link, {
        to: "/quan-ly/bo-phan/danh-sach",
        class: "btn btn-primary align-self-center"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "form",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"])),
        model: _ctx.form,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_form_item, {
                prop: "name",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    name: "name",
                    onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                prop: "code",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.code,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.code) = $event)),
                    name: "code",
                    disabled: !_ctx.isCreating,
                    readonly: !_ctx.isCreating
                  }, null, 8, ["modelValue", "disabled", "readonly"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_form_item, {
                prop: "description",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    autosize: { minRows: 2 },
                    resize: "none",
                    type: "textarea",
                    modelValue: _ctx.form.description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.description) = $event)),
                    name: "description",
                    onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_form_item, {
                prop: "address",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    autosize: { minRows: 2 },
                    resize: "none",
                    type: "textarea",
                    modelValue: _ctx.form.address,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.address) = $event)),
                    name: "address",
                    onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_form_item, {
                prop: "address",
                class: "mb-0 w-100"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.departmentDetail.name,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.departmentDetail.name) = $event)),
                    name: "address",
                    disabled: "",
                    onFocus: _cache[8] || (_cache[8] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"])),
              class: "btn btn-white me-3 col-2"
            }, " Xóa thông tin đã nhập "),
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.CANCEL,
              "color-type": _ctx.ButtonTypeColors.DANGER,
              onClick: _withModifiers(_ctx.resetForm, ["prevent"])
            }, {
              "button-label": _withCtx(() => [
                _createTextVNode("Xóa thông tin đã nhập")
              ]),
              _: 1
            }, 8, ["button-type", "color-type", "onClick"]),
            _createVNode(_component_ButtonCustom, {
              "button-type": _ctx.ButtonsType.SAVE,
              "color-type": _ctx.ButtonTypeColors.SUCCESS,
              disabled: _ctx.loading,
              "is-loading": _ctx.loading,
              onClick: _ctx.onSubmit
            }, {
              "button-label": _withCtx(() => [
                _createTextVNode("Lưu")
              ]),
              _: 1
            }, 8, ["button-type", "color-type", "disabled", "is-loading", "onClick"]),
            _hoisted_27
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}